import React from 'react';

import classes from './DropdownMenuItem.scss';

const dropdownMenuItem = (props) => (
    <div {...props} className={classes.Item}>{props.children}</div>
)

export default dropdownMenuItem;


// WEBPACK FOOTER //
// ./src/components/UI/DropdownMenu/DropdownMenuItem/DropdownMenuItem.js